
import React from 'react';
import { useLanguage } from '@/contexts/LanguageContext';
import Header from '@/components/Header';
import Footer from '@/components/Footer';
import { Card, CardContent } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';

const Privacy = () => {
  const { language } = useLanguage();

  const sections = [
    {
      title: language === 'ar' ? 'المعلومات التي نجمعها' : 'Information We Collect',
      content: language === 'ar' 
        ? 'نجمع المعلومات التي تقدمها لنا مباشرة، مثل عند إنشاء حساب أو الاتصال بنا. قد نجمع أيضاً معلومات حول كيفية استخدامك لخدماتنا.'
        : 'We collect information you provide directly to us, such as when you create an account or contact us. We may also collect information about how you use our services.'
    },
    {
      title: language === 'ar' ? 'كيف نستخدم المعلومات' : 'How We Use Information',
      content: language === 'ar'
        ? 'نستخدم المعلومات لتقديم وتحسين خدماتنا، والتواصل معك، وضمان أمان منصتنا.'
        : 'We use information to provide and improve our services, communicate with you, and ensure the security of our platform.'
    },
    {
      title: language === 'ar' ? 'مشاركة المعلومات' : 'Information Sharing',
      content: language === 'ar'
        ? 'لا نبيع أو نؤجر معلوماتك الشخصية لأطراف ثالثة. قد نشارك المعلومات في حالات محددة موضحة في هذه السياسة.'
        : 'We do not sell or rent your personal information to third parties. We may share information in specific circumstances outlined in this policy.'
    },
    {
      title: language === 'ar' ? 'أمان البيانات' : 'Data Security',
      content: language === 'ar'
        ? 'نتخذ تدابير أمنية مناسبة لحماية معلوماتك من الوصول غير المصرح به أو الكشف أو التغيير أو التدمير.'
        : 'We implement appropriate security measures to protect your information against unauthorized access, disclosure, alteration, or destruction.'
    },
    {
      title: language === 'ar' ? 'حقوقك' : 'Your Rights',
      content: language === 'ar'
        ? 'لديك الحق في الوصول إلى معلوماتك الشخصية وتصحيحها أو حذفها. يمكنك أيضاً الاعتراض على معالجة بياناتك في ظروف معينة.'
        : 'You have the right to access, correct, or delete your personal information. You may also object to the processing of your data in certain circumstances.'
    }
  ];

  return (
    <div className={`min-h-screen ${language === 'ar' ? 'rtl' : 'ltr'}`}>
      <Header />
      
      <main className="container mx-auto px-4 py-12">
        <div className="max-w-4xl mx-auto">
          {/* Hero Section */}
          <div className="text-center mb-12">
            <Badge variant="secondary" className="mb-4">
              {language === 'ar' ? 'سياسة الخصوصية' : 'Privacy Policy'}
            </Badge>
            <h1 className="text-4xl font-bold mb-6">
              {language === 'ar' ? 'سياسة الخصوصية' : 'Privacy Policy'}
            </h1>
            <p className="text-muted-foreground">
              {language === 'ar' 
                ? 'آخر تحديث: ديسمبر 2024'
                : 'Last updated: December 2024'
              }
            </p>
          </div>

          {/* Introduction */}
          <Card className="mb-8">
            <CardContent className="p-8">
              <p className="text-lg">
                {language === 'ar'
                  ? 'نحن في منصة الإسكان الطلابي نحترم خصوصيتك ونلتزم بحماية معلوماتك الشخصية. توضح هذه السياسة كيف نجمع ونستخدم ونحمي معلوماتك.'
                  : 'At Student Housing, we respect your privacy and are committed to protecting your personal information. This policy explains how we collect, use, and protect your information.'
                }
              </p>
            </CardContent>
          </Card>

          {/* Sections */}
          <div className="space-y-8">
            {sections.map((section, index) => (
              <Card key={index}>
                <CardContent className="p-8">
                  <h2 className="text-2xl font-bold mb-4">{section.title}</h2>
                  <p className="text-muted-foreground leading-relaxed">
                    {section.content}
                  </p>
                </CardContent>
              </Card>
            ))}
          </div>

          {/* Contact Section */}
          <Card className="mt-12">
            <CardContent className="p-8 text-center">
              <h2 className="text-2xl font-bold mb-4">
                {language === 'ar' ? 'اتصل بنا' : 'Contact Us'}
              </h2>
              <p className="text-muted-foreground mb-4">
                {language === 'ar'
                  ? 'إذا كان لديك أي أسئلة حول سياسة الخصوصية هذه، يرجى الاتصال بنا:'
                  : 'If you have any questions about this Privacy Policy, please contact us:'
                }
              </p>
              <p className="font-medium">support@studenthousing.eg</p>
            </CardContent>
          </Card>
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default Privacy;
